import React from 'react';
import Widget from "../../../../../components/prefabricated/Widget";
import {Col, Row} from "reactstrap";

const PointOfContactWidget = ({customer=null,}) => {
    return(
        <Widget className={"text-center p-2"}>
            <Row>
                <Col>
                    <h2 >Account Owner</h2>
                </Col>
            </Row>
            <Row>
                <Col>
                    <br/>
                </Col>
            </Row>
            {/*<h5 >For contract, technical, and other matters regarding your company's account.</h5>*/}
            <Row>
                <Col>
                    <p><strong>Name:</strong> {customer && customer["CustomerPocName"] ? customer["CustomerPocName"] : "--"}</p>
                </Col>
            </Row>
            <Row>
                <Col>
                    <p><strong>Email:</strong> {customer && customer["CustomerPocEmail"] ? customer["CustomerPocEmail"] : "--"}</p>
                </Col>
            </Row>
            {/*<p><strong>Phone:</strong> {customer && customer["CustomerPocPhone"] ? customer["CustomerPocPhone"] : "--"}</p>*/}
        </Widget>

    )
}

export default PointOfContactWidget;